<template>
  <div class="data-content-box">
    <dragPanel v-show="dataManageTreeVisible">
      <data-manage-tree
        :width="242"
        ref="dataManageTree"
        :data="treeData"
        :nodeClick="handleNodeClick"
        :hideDataManageTree="hideDataManageTree" />
    </dragPanel>
    <div
      v-if="!dataManageTreeVisible"
      class="icon-box">
      <icon-svg
        icon-class="ic-ico_an"
        class="icon"
        title="展开目录树"
        @click.native="openDataManageTree" />
    </div>
    <div class="data-content page-primary">
      <div
        v-if="loading"
        class="loading-box">
        <div
          v-loading="true"
          class="loading" />
      </div>
      <breadcrumb
        :breadcrumbList="breadcrumbList"
        :breadcrumbClick="breadcrumbClick" />
      <div class="operate-area">
        <div class="common-button-box">
          <div v-if="isButtonVisible('upload')">
            <el-button
              id="point-cloud-upload"
              class="upload-btn primary-btn gr9"
              type="primary"
              size="small"
              @click="uploadFile">
              上传
            </el-button>
          </div>
          <div v-if="isButtonVisible('newFolder')">
            <el-button
              size="small"
              class="normal-btn gr9"
              @click="addNode(1)"
              >新建文件夹</el-button
            >
          </div>
          <div
            v-if="isBatchButtonVisible('modelBatchOperate', '')"
            class="common-dropdown-box">
            <el-dropdown
              placement="bottom-start"
              @command="modelBatchOperate">
              <el-button
                size="small"
                class="normal-btn">
                批量操作 <i class="el-icon-arrow-down" />
              </el-button>
              <el-dropdown-menu
                slot="dropdown"
                class="dropdown-menu dropdown-primary"
                :append-to-body="false">
                <el-dropdown-item
                  v-if="
                    isBatchButtonVisible('setCoordinate', 'modelBatchOperate')
                  "
                  command="0">
                  设置坐标系
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    isBatchButtonVisible('submitConvert', 'modelBatchOperate')
                  "
                  command="1">
                  提交转换
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isBatchButtonVisible('download', 'modelBatchOperate')"
                  command="2">
                  下载
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isBatchButtonVisible('moveTo', 'modelBatchOperate')"
                  command="3">
                  移动到
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isBatchButtonVisible('deleteNode', 'modelBatchOperate')"
                  command="5">
                  删除
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isBatchButtonVisible('share', 'modelBatchOperate')"
                  command="6">
                  分享
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div>
          <el-input
            class="search-input input-primary"
            size="small"
            v-model="keywords"
            placeholder="请输入文件名"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search icon"
              @click="search" />
          </el-input>
        </div>
      </div>
      <div
        v-if="!modelTableVisible"
        class="common-empty-box"
        key="emptyPage">
        <bj-empty
          :image="getNoDataImg()"
          class="empty-page">
          <template slot="description">
            <div
              :class="`${
                isMicroAppMode() ? 'description-box empty-text' : 'empty-text'
              }`">
              抱歉，没有找到相关内容
            </div>
          </template>
          <div
            class="empty-tips"
            v-if="isButtonVisible('upload')">
            点云数据需以zip包格式上传，且每种格式（asc、pts、las、e57、pcd、ply）需各自打包成一个独立的zip包。
          </div>
          <div class="common-button-box text-center-c btn-group-primary">
            <el-button
              v-if="isButtonVisible('upload')"
              key="uploadBtn"
              type="primary"
              size="small"
              class="upload-btn primary-btn gr9"
              id="empty-point-cloud-upload"
              @click="uploadFile">
              上传
            </el-button>
            <el-button
              v-if="isButtonVisible('newFolder')"
              class="normal-btn"
              size="small"
              @click="addNode(1)">
              新建文件夹
            </el-button>
          </div>
        </bj-empty>
      </div>
      <div
        v-show="modelTableVisible"
        class="data-view-box">
        <model-table
          :operaWidth="200"
          ref="modelTable"
          v-show="modelTableVisible"
          schemeType="PointCloud"
          :rootNodeId="rootNodeId"
          :nodeId="selectNodeData.nodeId"
          :name="keywords"
          :customUploader="customUploader"
          :updateModelTableVisible="updateModelTableVisible"
          :refreshCatalogTree="refreshCatalogTree"
          :handleCellClick="handleCellClick"
          :reNameNode="reNameNode"
          :submitConvert="submitConvert"
          :openMoveTreeDialog="openMoveTreeDialog"
          :openCoordinateDialog="openCoordinateDialog"
          :openShareDialog="openShareDialog"
          :openPointCloudConfigDialog="openPointCloudConfigDialog" />
      </div>
    </div>
    <add-node-dialog
      :visible="nodeDialogVisible"
      :title="nodeDialogTitle"
      schemeType="PointCloud"
      :nodeType="nodeType"
      :editMode="editMode"
      :nodeInfo="nodeInfo"
      :submitNode="submitNode"
      :closeDialog="closeNodeDialog" />
    <CoordinateDialog
      :visible="coordinateDialogVisible"
      dataSetType="PointCloud"
      :initCrsInfo="initCrsInfo"
      :submitInfo="setNodeCoordinates"
      :closeDialog="closeCoordinateDialog" />
    <CrsCheckDialog
      :visible="crsCheckDislogVisible"
      :readOnlyInfo="{}"
      :dataSetsIsQuoted="dataSetsIsQuoted"
      :continueSetCrs="continueSetCrs"
      :closeDialog="closeCrsCheckDialog" />
    <moveTreeDialogVue
      :visible="moveTreeDialogVisible"
      :data="moveTreeData"
      :nodeClick="moveTreeNodeClick"
      :submitMove="submitMove"
      :closeDialog="closeMoveTreeDialog" />
    <shareDialog
      :visible="shareDialogVisible"
      resourceType="dataSet"
      :resourceList="dataSetsToShare"
      :closeDialog="closeShareDialog" />
    <PointCloudFileConfig
      :visible="pointCloudConfigDialogVisible"
      :dataSetsToConvert="dataSetsToConvert"
      :submitConvert="submitConvert"
      :closeDialog="closePointCloudConfigDialog" />
    <VerifyMsgDialog :customUploader="customUploader" />
  </div>
</template>

<script>
import dragPanel from '@/components/DragPanel.vue'
import dataManageTree from '@/components/module/dataManage/DataManageTree.vue'
import breadcrumb from '@/components/module/dataManage/Breadcrumb.vue'
import moveTreeDialogVue from '@/components/module/dataManage/MoveTreeDialog.vue'
import addNodeDialog from '@/components/module/dataManage/AddNodeDialog.vue'
import modelTable from '@/components/module/dataManage/ModelTable.vue'
import CoordinateDialog from '@/components/CoordinateDialog.vue'
import CrsCheckDialog from '@/components/CrsCheckDialog.vue'
import shareDialog from '@/components/ShareDialog.vue'
import VerifyMsgDialog from '@/components/module/dataManage/VerifyMsgDialog.vue'
import PointCloudFileConfig from './components/PointCloudFileConfig.vue'

import CustomUploader from '@/utils/customUploader'
import { getParentNode, findNodeById } from '@/utils/generalMethods'

import { Store } from '@/utils/store'
import { pointCloudButtons } from '@/utils/dictionary'
import { isMicroAppMode } from '@/microAdapt/utils'

import {
  getPointCloudTreeService,
  addPointCloudLevelNodes,
  modifyPointCloudNodeName,
  pointCloudQuoteService,
  setPointCloudCoordinatesService,
  movePointCloudNode,
  addPointCloudConvertQueue
} from '@/service/interface'
export default {
  data() {
    return {
      dataManageTreeVisible: true,
      rootNodeId: '',
      rootNodeData: {},
      treeData: [],
      selectNodeData: {},

      loading: true,
      modelTableVisible: false,

      keywords: '',
      breadcrumbList: [{ id: 'all', name: '点云' }],

      nodeDialogVisible: false,
      nodeDialogTitle: '',
      nodeType: 0,
      nodeInfo: null,
      editMode: '',

      moveTreeDialogVisible: false,
      moveTreeData: [],
      moveNodeData: null,

      crsCheckDislogVisible: false,
      dataSetsIsQuoted: [],
      coordinateDialogVisible: false,
      initCrsInfo: {},
      dataSetIdsToSetCrs: [],

      shareDialogVisible: false,
      dataSetsToShare: [],

      pointCloudConfigDialogVisible: false,
      dataSetsToConvert: []
    }
  },
  components: {
    dragPanel,
    dataManageTree,
    breadcrumb,
    moveTreeDialogVue,
    addNodeDialog,
    modelTable,
    CoordinateDialog,
    CrsCheckDialog,
    shareDialog,
    PointCloudFileConfig,
    VerifyMsgDialog
  },
  created() {
    let uploaders = Store.uploaders
    let find = uploaders.find(el => el.schemeType === 'PointCloud')
    if (find) {
      this.customUploader = find.uploader
      this.customUploader.setCurrDataSetId('')
      this.customUploader.setUploadPathName('')
    } else {
      let uploaderOption = {
        accept: {
          title: '点云',
          extensions: 'zip,rar,7z',
          mimeTypes: 'application/zip'
        }
      }
      this.customUploader = new CustomUploader('PointCloud', uploaderOption)
    }

    let projId = this.$route.params.projId
    this.customUploader.setCurrProjId(projId)
  },
  mounted() {
    this.initData().then(() => {
      let nodeId = sessionStorage.getItem('PointCloudNodeId')
      if (nodeId) {
        let selectData = this.findNodeById(this.treeData, nodeId)
        let domRef = this.$refs.dataManageTree
        if (selectData && domRef) {
          let node = domRef.getNode(selectData.nodeId)
          this.handleNodeClick(selectData, node)
        }
        sessionStorage.removeItem('PointCloudNodeId')
      } else {
        let domRef = this.$refs.dataManageTree
        if (domRef) {
          let node = domRef.getNode(this.rootNodeData.nodeId)
          this.handleNodeClick(this.rootNodeData, node)
        }
      }
    })

    this.customUploader.on('startUploadFile', this.onStartUploadFile)
    this.$eventManage.on('refresh-catalogTree', this.refreshCatalogTree)
    this.$eventManage.on('refreshTable', this.refreshTable)
  },
  beforeDestroy() {
    this.customUploader.off('startUploadFile', this.onStartUploadFile)
    this.$eventManage.off('refresh-catalogTree', this.refreshCatalogTree)
    this.$eventManage.off('refreshTable', this.refreshTable)
  },
  methods: {
    openDataManageTree() {
      this.dataManageTreeVisible = true
    },
    hideDataManageTree() {
      this.dataManageTreeVisible = false
    },
    initData() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getPointCloudTreeService({ projId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data) {
              this.rootNodeData = data
              this.rootNodeId = data.rootId
              this.treeData = [data]
              this.moveTreeData = [data]
              resolve()
            } else {
              this.$message.error('获取资源目录失败，请稍后再试')
              this.$router.push('../../../projectList')
            }
          } else {
            this.$message.error(response.errMsg)
            this.$router.push('../../../projectList')
          }
        })
      })
    },
    refreshCatalogTree() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getPointCloudTreeService({ projId }).then(response => {
          if (response.isSuccess) {
            this.rootNodeData = response.data
            this.treeData = [response.data]
            this.moveTreeData = [response.data]
            this.$nextTick(() => {
              let nodeId = this.selectNodeData.nodeId
              let selectData = this.findNodeById([response.data], nodeId)
              let domRef = this.$refs.dataManageTree
              if (selectData && domRef) {
                this.selectNodeData = selectData
                domRef.setCurrentKey(selectData.nodeId)
              }
            })
            resolve()
          } else {
            this.$message.error(response.errMsg)
            this.$router.push('../../../projectList')
          }
        })
      })
    },
    refreshTable() {
      if (this.$refs.modelTable) {
        if (!this.selectNodeData.nodeId) return
        this.$refs.modelTable.uploadDataList().then(total => {
          this.updateModelTableVisible(total)
        })
      }
    },
    search() {
      sessionStorage.removeItem('pageInfo')
      this.$refs.modelTable.uploadDataList(1)
    },
    handleCellClick(row) {
      let node = this.$refs.dataManageTree.getNode(row.nodeId)
      this.handleNodeClick(row, node)
    },
    handleNodeClick(nodeData, node) {
      this.loading = true
      this.selectNodeData = nodeData
      this.breadcrumbList = this.getBreadCrumbList(node)

      this.keywords = ''
      this.$refs.dataManageTree.setCurrentKey(nodeData.nodeId)
      sessionStorage.setItem('PointCloudNodeId', nodeData.nodeId)

      this.$nextTick(() => {
        this.$refs.modelTable.uploadDataList(1).then(total => {
          this.updateModelTableVisible(total)
          this.loading = false
        })
      })
    },
    getBreadCrumbList(node) {
      let breadcrumbList = []
      if (node) {
        let parentNodes = []
        this.getParentNode(node, parentNodes)
        parentNodes.reverse()
        parentNodes.forEach(item => {
          let nodeData = item.data
          if (nodeData.nodeType === 0) {
            breadcrumbList.push({
              id: nodeData.nodeId,
              name: '点云'
            })
          } else {
            breadcrumbList.push({
              id: nodeData.nodeId,
              name: nodeData.nodeName
            })
          }
        })
      } else {
        breadcrumbList = [{ id: this.rootNodeId, name: '点云' }]
      }
      return breadcrumbList
    },
    breadcrumbClick(data) {
      if (this.breadcrumbList.length === 1) return
      if (data.id === this.rootNodeId) {
        this.selectNodeData = this.rootNodeData
        this.$refs.dataManageTree.setCurrentKey(null)
        this.handleNodeClick(this.rootNodeData)
      } else {
        let selectData = this.findNodeById(this.treeData, data.id)
        let node = this.$refs.dataManageTree.getNode(selectData.nodeId)
        this.handleNodeClick(selectData, node)
      }
    },
    uploadFile() {
      this.customUploader.setStatus('waiting')
    },
    onStartUploadFile() {
      this.$eventManage.fire('startUploadFile')
    },
    modelBatchOperate(command) {
      switch (command) {
        case '0':
          this.$refs.modelTable.batchSetCoordinate()
          break
        case '1':
          this.$refs.modelTable.batchSubmitConvertFiles()
          break
        case '2':
          this.$refs.modelTable.batchDownloadFiles()
          break
        case '3':
          this.$refs.modelTable.batchMoveNode()
          break
        case '5':
          this.$refs.modelTable.batchDeleteNode()
          break
        case '6':
          this.$refs.modelTable.batchShare()
          break
        default:
          break
      }
    },
    addNode(nodeType) {
      let node = this.$refs.dataManageTree.getNode(this.selectNodeData.nodeId)
      if (node && node.level > window.maxLevel) {
        this.$message.warning(`最多只支持${window.maxLevel + 1}级`)
        return false
      }

      this.nodeDialogVisible = true
      this.nodeDialogTitle = '新建文件夹'
      this.nodeType = nodeType
      this.editMode = 'addNode'
    },
    reNameNode(nodeInfo) {
      let nodeType = nodeInfo.nodeType

      this.nodeDialogVisible = true
      this.nodeDialogTitle = nodeType === 1 ? '重命名文件夹' : '重命名模型组'
      this.nodeType = nodeType
      this.editMode = 'reNameNode'
      this.nodeInfo = nodeInfo
    },
    closeNodeDialog() {
      this.nodeDialogVisible = false
      this.nodeDialogTitle = ''
      this.nodeType = 0
      this.editMode = ''
      this.nodeInfo = null
    },
    submitNode(paramsInfo) {
      return new Promise(resolve => {
        if (this.editMode === 'addNode') {
          let params = {
            parentId: this.selectNodeData.nodeId,
            nodeNames: [paramsInfo.nodeName]
          }
          if (this.nodeType === 1) {
            addPointCloudLevelNodes(params).then(result => {
              if (result.isSuccess) {
                let data = result.data[0]
                this.refreshCatalogTree().then(() => {
                  let selectData = this.findNodeById(this.treeData, data.nodeId)
                  if (selectData) {
                    let node = this.$refs.dataManageTree.getNode(
                      selectData.nodeId
                    )
                    this.handleNodeClick(selectData, node)
                  }
                })
                resolve(result)
              } else {
                resolve(result)
              }
            })
          }
        }

        let dataInfo = this.nodeInfo
        if (this.editMode === 'reNameNode') {
          let params = {
            nodeId: dataInfo.nodeId,
            nodeName: paramsInfo.nodeName
          }
          modifyPointCloudNodeName(params).then(result => {
            if (result.isSuccess) {
              this.refreshCatalogTree()
              this.refreshTable()
              resolve(result)
            } else {
              resolve(result)
            }
          })
        }
      })
    },
    openMoveTreeDialog(datas) {
      this.nodesToMove = datas
      this.moveTreeDialogVisible = true
    },
    moveTreeNodeClick(data, node) {
      this.moveNodeData = null

      if (data.nodeId === this.selectNodeData.nodeId) {
        this.$message.error('数据已在当前目录中，请选择其他目录！')
        return
      }

      let moveDataIds = this.nodesToMove.map(el => el.nodeId)
      if (moveDataIds.includes(data.nodeId)) {
        this.$message.error('不能移动到自身目录之下，请选择其他目录！')
        return
      }

      let nodesToMoveNodeType = this.nodesToMove.map(el => el.nodeType)[0]
      if (nodesToMoveNodeType === 1 && node.level > window.maxLevel) {
        this.$message.error(`文件夹最多支持${window.maxLevel + 1}级，请选择其他目录！`)
        return
      }

      let parentNodes = []
      this.getParentNode(node, parentNodes)
      let parentNodeIds = parentNodes.map(el => el.data.nodeId)
      parentNodeIds.forEach(item => {
        if (moveDataIds.includes(item)) {
          this.$message.error('不能移动到子目录之下，请选择其他目录！')
          return
        }
      })

      this.moveNodeData = data
    },
    submitMove() {
      if (!this.moveNodeData) {
        this.$message.error('请选择有效的目标目录！')
        return
      }

      let params = {
        targetNodeId: this.moveNodeData.nodeId,
        nodeIds: this.nodesToMove.map(el => el.nodeId)
      }
      movePointCloudNode(params).then(response => {
        if (response.isSuccess) {
          this.refreshCatalogTree()
          this.refreshTable()

          this.$message.success('移动成功!')
          this.moveNodeData = null
          this.nodesToMove = []
          this.moveTreeDialogVisible = false
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    closeMoveTreeDialog() {
      this.moveNodeData = null
      this.nodesToMove = []
      this.moveTreeDialogVisible = false
    },
    openCoordinateDialog(dataSetIdsToSetCrs, dataSetInfo) {
      this.dataSetIdsToSetCrs = dataSetIdsToSetCrs
      if (dataSetInfo) {
        let initCrsInfo = {
          coordinatesConfig: dataSetInfo.coordinatesConfig,
          coordinatesDefault: dataSetInfo.coordinatesDefault
        }
        this.initCrsInfo = initCrsInfo
      }

      let dataSetIds = dataSetIdsToSetCrs
      pointCloudQuoteService({ dataSetIds }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let dataSets = data.dataSets
          if (dataSets.length) {
            this.dataSetsIsQuoted = dataSets
            this.openCrsCheckDialog()
          } else {
            this.coordinateDialogVisible = true
          }
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    openCrsCheckDialog() {
      this.crsCheckDislogVisible = true
    },
    continueSetCrs() {
      this.coordinateDialogVisible = true
    },
    closeCrsCheckDialog() {
      this.dataSetsIsQuoted = []
      this.crsCheckDislogVisible = false
    },
    setNodeCoordinates(params) {
      params.dataSetIds = this.dataSetIdsToSetCrs
      return new Promise(resolve => {
        setPointCloudCoordinatesService(params).then(response => {
          if (response.isSuccess) {
            this.$message.success('设置坐标系成功')
            this.refreshTable()
            resolve(response)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    closeCoordinateDialog() {
      this.dataSetIdsToSetCrs = []
      this.initCrsInfo = {}
      this.coordinateDialogVisible = false
    },
    openShareDialog(dataSetsToShare) {
      this.dataSetsToShare = dataSetsToShare
      this.shareDialogVisible = true
    },
    closeShareDialog() {
      this.dataSetsToShare = []
      this.shareDialogVisible = false
    },
    openPointCloudConfigDialog(dataSets) {
      this.dataSetsToConvert = dataSets
      this.pointCloudConfigDialogVisible = true
    },
    submitConvert() {
      let promiseArray = []
      this.dataSetsToConvert.forEach(item => {
        let params = {
          dataSetId: item.dataSetId,
          execConvertingCallback: ''
        }
        let promise = addPointCloudConvertQueue(params)
        promiseArray.push(promise)
      })

      Promise.all(promiseArray)
        .then(response => {
          if (response.length === promiseArray.length) {
            this.refreshCatalogTree()
            this.refreshTable()
          }
        })
        .catch(error => {
          this.refreshCatalogTree()
          this.refreshTable()
        })
    },
    closePointCloudConfigDialog() {
      this.pointCloudConfigDialogVisible = false
      this.dataSetsToConvert = []
      this.nodeInfo = null
    },
    updateModelTableVisible(total) {
      let visible = false
      if (total) {
        visible = true
      }
      this.modelTableVisible = visible

      this.$nextTick(() => {
        this.initUploadBtn()

        let projName = this.$route.params.projName
        let levelPathName = this.selectNodeData.levelPathName
        this.customUploader.setCurrDataSetId(this.selectNodeData.nodeId)
        this.customUploader.setUploadPathName(`${projName}/${levelPathName}`)
      })
    },
    initUploadBtn() {
      let uploadDom = document.getElementById('point-cloud-upload')
      if (uploadDom) {
        let child = uploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({ id: '#point-cloud-upload' })
        }
      }

      // 空态页上传按钮
      let emptyUploadDom = document.getElementById('empty-point-cloud-upload')
      if (emptyUploadDom) {
        let child = emptyUploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({
            id: '#empty-point-cloud-upload'
          })
        }
      }
    },
    isBatchButtonVisible(buttonName, parentButtonName) {
      let visible = false
      if (Object.keys(this.selectNodeData).length) {
        if (parentButtonName) {
          let childrens = pointCloudButtons.find(
            el => el.name === parentButtonName
          ).children
          let find = childrens.find(el => el.name === buttonName)
          visible = this.isChecked(find.permissionCode)
        } else {
          let childrens = pointCloudButtons.find(
            el => el.name === buttonName
          ).children
          visible = childrens.some(el => this.isChecked(el.permissionCode))
        }

        if (visible) {
          visible = this.selectNodeData.isAuthorized
        }
      }
      return visible
    },
    isButtonVisible(buttonName) {
      let visible = false
      if (Object.keys(this.selectNodeData).length) {
        let find = pointCloudButtons.find(el => el.name === buttonName)
        visible = this.isChecked(find.permissionCode)

        if (visible) {
          visible = this.selectNodeData.isAuthorized
        }
      }
      return visible
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getNoDataImg() {
      if (isMicroAppMode()) {
        return require('@/assets/img/no-data-nebula.png')
      } else {
        return require('@/assets/img/no-data.png')
      }
    },
    getParentNode,
    findNodeById,
    isMicroAppMode
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';

.data-content-box {
  .data-content {
    margin-left: 16px;
    padding: 16px;
    margin-bottom: 0;
    overflow: hidden;
    .operate-area {
      width: 100%;
    }

    .data-view-box {
      height: calc(100% - 96px);
    }
  }
}
.select-disable {
  .el-table__header-wrapper .el-checkbox {
    //找到表头那一行，然后把里面的复选框隐藏掉
    pointer-events: none;
    cursor: not-allowed;
  }
}
</style>
